import React, { useEffect, useMemo, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { loginRequest } from '../auth/authConfig';
import './LoginPage.css';

const LoginPage: React.FC = () => {
  const { instance, accounts, inProgress } = useMsal();
  const [isSigningIn, setIsSigningIn] = useState(false);
  const isBusy = useMemo(
    () => isSigningIn || inProgress !== InteractionStatus.None,
    [isSigningIn, inProgress]
  );

  useEffect(() => {
    // After a redirect return, ensure an account is marked active.
    if (!instance.getActiveAccount() && accounts.length > 0) {
      instance.setActiveAccount(accounts[0]);
    }
  }, [accounts, instance]);

  const handleLogin = async () => {
    if (isBusy) {
      return;
    }

    setIsSigningIn(true);
    try {
      await instance.loginRedirect(loginRequest);
    } catch (error: any) {
      console.error('Login redirect error:', error);
      setIsSigningIn(false);
    } finally {
      // If redirect starts, browser leaves this page before finally executes.
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-card">
          <div className="login-split">
            <div className="login-logo-side">
              <img
                src="/logo192.png"
                alt="Ask Joseph"
                className="login-logo"
              />
            </div>
            <div className="login-signin-side">
              <button onClick={handleLogin} className="btn-primary btn-large" disabled={isBusy}>
                {isBusy ? 'Signing in...' : 'Sign in with Microsoft'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
